import React, { useMemo, useRef } from 'react';
import cx from 'classnames';
import { ICustomTable } from './type';
import './index.scss';
import useScrollbar from './useScrollbar';

const CustomTable = (props: ICustomTable) => {
  const {
    className,
    style,
    columns,
    records,
    addons,
    // recordKey,
  } = props || {};
  const { rowSpan } = addons || {};
  const tableRef = useRef(null);
  const { hasXScrollbar, scrollLeft } = useScrollbar(tableRef, { horizontal: true });
  const colgroupDom = useMemo(() => <colgroup>{columns?.map((column, columnIndex) => (<col key={columnIndex} style={{ width: column?.width ? column?.width : "auto" }}></col>))}</colgroup>, [columns]);

  return (
    <div className={cx("dbh-custom-table", className, { "dbh-custom-table-scroll": hasXScrollbar && scrollLeft > 0 })} style={style} ref={tableRef}>
      <div className="dbh-custom-table-header">
        <table className='dbh-custom-table-box'>
          {colgroupDom}
          <thead>
            {/* 渲染表头 */}
            <tr className="dbh-custom-table-row">
              {columns?.map((column, columnIndex) => {
                const { header, align, fixed, } = column;
                const alignClass = align ? `dbh-custom-table-text-${align}` : "";
                const left = columns?.slice(0, columnIndex).reduce((prev: any, cur: any) => prev + (cur?.width || 0), 0);
                return (
                  <th
                    key={columnIndex}
                    style={fixed ? { left } : {}}
                    className={cx(`dbh-custom-table-col ${alignClass}`, { 'dbh-custom-table-col-fixed': fixed })}
                  >
                    <div className={cx(`dbh-custom-table-header-title`)}>
                      {typeof header === 'function' ? header?.(column) : header}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
        </table>
      </div>
      <div className="dbh-custom-table-body">
        <table className='dbh-custom-table-box' >
          {colgroupDom}
          <tbody>
            {records?.map((record, recordIndex) => (
              <tr key={recordIndex} className="dbh-custom-table-row">
                {columns?.map((column, columnIndex) => {
                  const { key: colKey, align, fixed, render } = column;
                  const alignClass = align ? `dbh-custom-table-text-${align}` : "";
                  const row = rowSpan ? rowSpan?.(columnIndex, recordIndex) : 1;
                  const left = columns?.slice(0, columnIndex).reduce((prev: any, cur: any) => prev + (cur?.width || 0), 0);
                  if (!row) return null;
                  return (
                    <td
                      key={columnIndex}
                      style={fixed ? { left } : {}}
                      className={cx(`dbh-custom-table-col ${alignClass}`, { 'dbh-custom-table-col-fixed': fixed })}
                      rowSpan={row}
                    // colSpan={colSpan ? colSpan?.(columnIndex, recordIndex) : 1}
                    >
                      {typeof render === 'function' ? render?.(record, colKey, recordIndex, column, columnIndex) : record[colKey]}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomTable;